import { Routes } from '@angular/router';
import { LoginComponent } from './Common/login/login.component';
import { ForgotPasswordComponent } from './Common/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './Common/reset-password/reset-password.component';
import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./Dashboard/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./Dashboard/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent
          ),
      },
      {
        path: 'report',
        loadComponent: () =>
          import('./Dashboard/report/report.component').then(
            (m) => m.ReportComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];


